import { gql } from '@apollo/client';

export const totalRowsQuery = gql`
  query ($personId: ID!, $initialRow: Int, $nextRows: Int) {
    pendingReturnProducts(personId: $personId, initialRow: $initialRow, nextRows: $nextRows){
      totalRows
    }
  }
`;
